import React from 'react';

export interface IReportsChildCountProps {
  /**
   * **This only for embedded editing contexts.**
   *
   * For reporting to a parent context, e.g. category, the number of children nested
   * within an otherwise hidden category node. This is necessary for editing contexts
   * that don't know about each other, since we aren't counting DOM nodes in React;
   * (data remains "source of truth" for DOM, not the other way around.)
   */
  reportChildCount?: (count: number) => void;
}

/**
 * This currently only for embedded editing contexts.
 *
 * However, this *could be expanded* if we wanted to report things like validation up
 * to the category level.
 */
export interface IEditorCategoryContext extends IReportsChildCountProps {
  /**
   * Set to `true` to keep the category from _un-mounting_ its direct children when it is collapsed.
   * Primary use-case is to preserve embedded editing context in memory, but it could also be used
   * to preserve other editors that are a bit expensive to re-render (rich text comes to mind).
   *
   * This will not also cause the children to render if the category has never been opened.
   */
  setPreserveChildren: (preserve: boolean) => void;
}

export const EditorCategoryContext = React.createContext<IEditorCategoryContext>({
  setPreserveChildren: () => {},
});
